import { FC } from 'react';

import { StaticCurrencySpan, StaticNumericSpan } from '@myn/mui';

import { Currency } from '../types/_campaigns/campaigns.js';

type Props = {
  currency?: Currency | null;
  value: string | number;
  decimals?: number;
};

const ConditionalCurrencyField: FC<Props> = ({ currency, value, decimals }) => {
  return currency ? (
    <StaticCurrencySpan currency={currency.value} number={value} />
  ) : (
    <StaticNumericSpan number={value} options={{ minDecimals: decimals }} />
  );
};
export default ConditionalCurrencyField;
